<template>
  <div class="home1-container">
    <div class="tab-first">
      <div class="left">
        <div class="item" v-for="(item,index) in navigation" :key="index"
          @click="clickFirst(index,0)" :class="index==index1?'active':''">
          <span class="zsf-icon" :class="item.icon"></span>
          <b>{{item.name}}</b>
        </div>
      </div>
      <div class="right">
        <div class="c-pointer">
          <span class="zsf-icon zsf-icon-touxiang mr-3"></span>
          <b>张三丰</b>
          <b class="ml-5">超级管理员</b>
        </div>
        <div class="c-pointer" @click="quit">
          <span class="zsf-icon zsf-icon-tuichu mr-3"></span>
          <b>退出</b>
        </div>
      </div>
    </div>
    <div class="tab-second">
      <div class="item" :class="index==index2?'active':''" @click="clickSecond(index)"
        v-for="(item,index) in navigation[index1].child" :key="index">{{item.name}}</div>
    </div>
    <div class="box">
      <div class="left">
        <div class="line mt-20">图表名称1</div>
        <div id="left-echarts" style="width:400px;height:250px;position:relative;top:-40px;"></div>
        <div class="line">图表名称2</div>
        <div id="left-echarts2" style="width:400px;height:250px;position:relative;top:-40px;"></div>
      </div>
      <div class="right"></div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { navigation } from "../../config.js";
export default {
  data() {
    return {
      navigation: navigation,
      index1: 0,
      index2: 0,
      myChart3: null
    };
  },

  computed: {},

  created() {},

  mounted() {
    this.leftEcharts(22, 33, 44, 55, 66);
    this.leftEcharts2(55, 13, 44, 55, 26);
  },

  methods: {
    leftEcharts(count1, count2, count3, count4, count5) {
      var d = [
        { name: "项目1", value: count1 },
        { name: "项目2", value: count2 },
        { name: "项目3", value: count3 },
        { name: "项目4", value: count4 },
        { name: "项目5", value: count5 }
      ];
      var dom = document.getElementById("left-echarts");
      if (
        this.myChart3 !== null &&
        this.myChart3 !== "" &&
        this.myChart3 !== undefined
      ) {
        this.myChart3.dispose();
      }
      this.myChart3 = this.$echarts.init(dom);
      var option = {
        //color: ['#FAAF19', '#4BA5EB', '#F08241', '#BE87EB', '#00B996'],
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: ["50%", "70%"],
            center: ["40%", "60%"],
            data: d,
            emphasis: {
              itemStyle: {
                shadowBlur: 0,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
                emphasis: {
                  shadowBlur: 2,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                }
              }
            }
          }
        ]
      };
      if (option && typeof option === "object") {
        this.myChart3.setOption(option, true);
      }
    },
    leftEcharts2(count1, count2, count3, count4, count5) {
      var d = [
        { name: "项目1", value: count1 },
        { name: "项目2", value: count2 },
        { name: "项目3", value: count3 },
        { name: "项目4", value: count4 },
        { name: "项目5", value: count5 }
      ];
      var dom = document.getElementById("left-echarts2");
      if (
        this.myChart4 !== null &&
        this.myChart4 !== "" &&
        this.myChart4 !== undefined
      ) {
        this.myChart4.dispose();
      }
      this.myChart4 = this.$echarts.init(dom);
      var option = {
        //color: ['#FAAF19', '#4BA5EB', '#F08241', '#BE87EB', '#00B996'],
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: ["50%", "70%"],
            center: ["40%", "60%"],
            data: d,
            emphasis: {
              itemStyle: {
                shadowBlur: 0,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
                emphasis: {
                  shadowBlur: 2,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                }
              }
            }
          }
        ]
      };
      if (option && typeof option === "object") {
        this.myChart4.setOption(option, true);
      }
    },
    clickFirst(index1, index2) {
      this.index1 = index1;
      this.index2 = index2;
    },
    clickSecond(index) {
      this.index2 = index;
    },
    quit() {
      this.$confirm("确定要退出吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$router.push({ path: "/login" });
      });
    }
  },

  components: {}
};
</script>

<style lang="less" rel="stylesheet/less" scoped="true">
.home1-container {
  width: 100%;
  height: 100%;
  background: #262626;
  padding: 20px;
  overflow-y: auto;
  .tab-first {
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    height: 60px;
    align-items: stretch;
    .left {
      flex: 1;
      width: 0;
      .item {
        cursor: pointer;
        border-radius: 4px 4px 0 0;
        background: #e4e4e4 linear-gradient(#f2f2f2, #ebebeb 85%, #cccccc)
          no-repeat;
        text-align: center;
        transition: All 0.2s ease;
        text-transform: uppercase;
        color: #666666;
        width: 95px;
        height: 60px;
        float: left;
        margin-right: 1px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        b {
          font-size: 14px;
          margin-top: 5px;
          font-weight: bold;
        }
        span {
          font-size: 20px;
        }
        &:hover,
        &.active {
          background: #3693cf;
          color: white;
        }
      }
    }
    .right {
      display: flex;
      justify-content: center;
      align-items: stretch;
      color: white;
      div {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
        b {
          opacity: 0.9;
        }
      }
    }
  }
  .tab-second {
    width: 100%;
    background: #3693cf linear-gradient(#3693cf, #3693cf 85%, #1f5a80) no-repeat;
    border-radius: 0 4px 0 0;
    height: 48px;
    line-height: 48px;
    padding-left: 7px;
    .item {
      transition: All 0.2s ease;
      color: white;
      line-height: 48px;
      height: 48px;
      padding: 0 10px;
      float: left;
      opacity: 0.7;
      cursor: pointer;
      &:hover,
      &.active {
        opacity: 1;
        /*font-weight: bold;*/
      }
    }
  }
  .box {
    width: 100%;
    height: auto;
    min-height: 800px;
    background: #f7f7f7;
    display: flex;
    align-items: stretch;
    .left {
      width: 350px;
      background: #f1f1f1;
      height: auto;
      min-height: 800px;
      .line {
        height: 50px;
        line-height: 50px;
        font-size: 16px;
        text-align: center;
      }
    }
    .right {
      flex: 1;
    }
  }
}
</style>
